export default __webpack_public_path__ + "static/media/back-arrow-1.3d0c1fde.svg";